import {
  AddAction,
  BaseAction,
  CommanderActions,
  DeleteAction,
  LoadAction,
  RotateAction,
  TranslateAction,
} from '../actions/index.js';
import {
  ActionFromType,
  ActionParameters,
  Commander,
  CommanderAction,
  CommanderActionTypesEnum,
} from '../types.js';

class NotImplementedAction extends BaseAction<any, any> {
  constructor(commander: Commander) {
    super(commander, null, null);
    throw new Error('Method not implemented.');
  }
}

const actionsMapping = {
  [CommanderActionTypesEnum.Translate]: TranslateAction,
  [CommanderActionTypesEnum.Delete]: DeleteAction,
  [CommanderActionTypesEnum.Rotate]: RotateAction,
  [CommanderActionTypesEnum.Load]: LoadAction,
  [CommanderActionTypesEnum.Add]: AddAction,
  // No implementatied actions
  [CommanderActionTypesEnum.Init]: NotImplementedAction,
  [CommanderActionTypesEnum.Duplicate]: NotImplementedAction,
  [CommanderActionTypesEnum.Undo]: NotImplementedAction,
  [CommanderActionTypesEnum.Redo]: NotImplementedAction,
  [CommanderActionTypesEnum.Clone]: NotImplementedAction,
  [CommanderActionTypesEnum.Unlink]: NotImplementedAction,
  [CommanderActionTypesEnum.Param]: NotImplementedAction,
  [CommanderActionTypesEnum.Remove]: NotImplementedAction,
  [CommanderActionTypesEnum.Move]: NotImplementedAction,
  [CommanderActionTypesEnum.Resize]: NotImplementedAction,
  [CommanderActionTypesEnum.Meta]: NotImplementedAction,
  [CommanderActionTypesEnum.Update]: NotImplementedAction,
} as const satisfies Record<
  CommanderActionTypesEnum,
  new (commander: Commander, ...args: any[]) => CommanderAction
>;

export type ActionArgsByType<TType extends CommanderActionTypesEnum> = ActionParameters<
  (typeof actionsMapping)[TType]
>;

/**
 * Create a new action instance based on the provided type.
 */
export const createActionFromType = <
  TType extends CommanderActionTypesEnum,
  TAction extends CommanderAction = CommanderActions
>(
  commander: Commander,
  type: TType,
  ...args: ActionArgsByType<TType>
): ActionFromType<TAction, TType> => {
  if (!actionsMapping[type]) {
    throw new Error(`Unknown action type: ${type}`);
  }
  // @ts-ignore
  return new actionsMapping[type](commander, ...args) as ActionFromType<TAction, TType>;
};
